import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftazureComponent } from './simple-icons-microsoftazure.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftazureComponent ],
    exports:      [ SimpleIconsMicrosoftazureComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftazureModule {}
